module.exports = __webpack_public_path__ + "assets/successSparkleC-c92f58.svg";